import { useContext } from 'react';
import { ConfigContext } from '../components/ConfigProvider';

export const useConfig = () => {
  const context = useContext(ConfigContext);
  const { config } = context;

  return config;
};
